import { render, staticRenderFns } from "./ResponseAreaTable.vue?vue&type=template&id=42d3f0ca"
import script from "./ResponseAreaTable.vue?vue&type=script&lang=js"
export * from "./ResponseAreaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports